<h2 mat-dialog-title>Delete Price Tier</h2>
<p mat-card-subtitle>Please enter the date this price will discontinued from.</p>

<mat-dialog-content class="mat-typography">
    <div class="price-tier-form-container">
        <form [formGroup]="priceTierForm" *ngIf="priceTierForm">
            <div class="row">
                <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Tier</mat-label>
                        <input matInput formControlName="tier" placeholder="Enter tier number">
                        <mat-error *ngIf="priceTierForm.get('tier')?.hasError('required')">
                            Tier is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-6">
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Effective To</mat-label>
                        <input matInput [matDatepicker]="picker" [min]="currentDate" formControlName="effective_to" placeholder="Enter effective to date">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>

                        <mat-error *ngIf="priceTierForm.get('effective_from')?.hasError('required')">
                            Effective To is required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <p mat-card-subtitle>For example if you select 4th Feb, the price will remain effective until midnight 3th Feb.</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-raised-button color="primary" (click)="removeTier()">
        Remove tier
    </button>
</mat-dialog-actions>
